import React, { useState, lazy } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    inquiry: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic will be added later
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <Layout data-id="element-185">
      {/* Hero Section */}
      <section className="relative py-32 px-4 border-b border-taupe-200 overflow-hidden" data-id="element-186">
        {/* Background Image */}
        <div className="absolute inset-0" data-id="element-187">
          <img src="https://cdn.magicpatterns.com/uploads/jC7CaYxXGxNkxzgJdLnaGW/Contact_Us_bg.png" alt="Down Home Interiors Team" className="w-full h-full object-cover object-center" data-id="element-188" />
          <div className="absolute inset-0 bg-white/80" data-id="element-189" />
        </div>

        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-190">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-191">
            Get in Touch
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-192">
            Let's Start a
            <br data-id="element-193" />
            <span className="italic" data-id="element-194">Conversation</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-195">
            Whether you're ready to start a project or just exploring ideas,
            we'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-24 px-4 bg-white" data-id="element-196">
        <div className="max-w-7xl mx-auto" data-id="element-197">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-198">
            {/* Contact Form */}
            <div className="lg:col-span-2" data-id="element-199">
              <div className="bg-cream-50 p-8 md:p-12 border border-taupe-200 shadow-card" data-id="element-200">
                <h2 className="text-2xl font-serif text-charcoal-900 mb-2" data-id="element-201">
                  Send Us a Message
                </h2>
                <p className="text-charcoal-900/60 mb-8" data-id="element-202">
                  Fill out the form below and we'll get back to you within 24
                  hours.
                </p>

                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-203">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-204">
                    <div data-id="element-205">
                      <label htmlFor="firstName" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-206">
                        First Name *
                      </label>
                      <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" placeholder="Jane" data-id="element-207" />
                    </div>
                    <div data-id="element-208">
                      <label htmlFor="lastName" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-209">
                        Last Name *
                      </label>
                      <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" placeholder="Doe" data-id="element-210" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-211">
                    <div data-id="element-212">
                      <label htmlFor="email" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-213">
                        Email Address *
                      </label>
                      <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" placeholder="jane@example.com" data-id="element-214" />
                    </div>
                    <div data-id="element-215">
                      <label htmlFor="phone" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-216">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" placeholder="(555) 123-4567" data-id="element-217" />
                    </div>
                  </div>

                  <div data-id="element-218">
                    <label htmlFor="inquiry" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-219">
                      Reason for Inquiry *
                    </label>
                    <select id="inquiry" name="inquiry" required value={formData.inquiry} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" data-id="element-220">
                      <option value="" data-id="element-221">Select an option</option>
                      <option value="interior-design" data-id="element-222">Interior Design</option>
                      <option value="staging" data-id="element-223">Staging</option>
                      <option value="window-treatments" data-id="element-224">
                        Window Treatments
                      </option>
                      <option value="retail" data-id="element-225">Retail / Product Question</option>
                      <option value="other" data-id="element-226">Other</option>
                    </select>
                  </div>

                  <div data-id="element-227">
                    <label htmlFor="message" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-228">
                      Message *
                    </label>
                    <textarea id="message" name="message" required rows={6} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors resize-none" placeholder="Tell us about your project or question..." data-id="element-229" />
                  </div>

                  <div className="pt-4" data-id="element-230">
                    <Button type="submit" size="lg" fullWidth data-id="element-231">
                      Send Message
                    </Button>
                    <p className="text-sm text-charcoal-900/60 text-center mt-4" data-id="element-232">
                      We typically respond within 24 hours during business days.
                    </p>
                  </div>
                </form>
              </div>
            </div>

            {/* Contact Information Sidebar */}
            <div className="space-y-6" data-id="element-233">
              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-234">
                <div className="flex items-start gap-3 mb-4" data-id="element-235">
                  <MapPin className="text-sage-500 flex-shrink-0 mt-1" size={20} data-id="element-236" />
                  <div data-id="element-237">
                    <h3 className="font-serif text-lg text-charcoal-900 mb-2" data-id="element-238">
                      Visit Us
                    </h3>
                    <address className="not-italic text-charcoal-900/70 text-sm leading-relaxed" data-id="element-239">
                      <a href="https://www.google.com/maps/search/?api=1&query=2729+E.+Grand+River+Ave.+Howell+MI+48843" target="_blank" rel="noopener noreferrer" className="hover:text-sage-500 transition-colors" data-id="element-240">
                        2729 E. Grand River Ave.
                        <br data-id="element-241" />
                        Howell, MI 48843
                      </a>
                    </address>
                  </div>
                </div>
                <a href="https://www.google.com/maps/search/?api=1&query=2729+E.+Grand+River+Ave.+Howell+MI+48843" target="_blank" rel="noopener noreferrer" data-id="element-242">
                  <Button variant="ghost" size="sm" fullWidth className="mt-2" data-id="element-243">
                    Get Directions
                  </Button>
                </a>
              </div>

              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-244">
                <div className="flex items-start gap-3 mb-4" data-id="element-245">
                  <Phone className="text-sage-500 flex-shrink-0 mt-1" size={20} data-id="element-246" />
                  <div data-id="element-247">
                    <h3 className="font-serif text-lg text-charcoal-900 mb-2" data-id="element-248">
                      Call Us
                    </h3>
                    <a href="tel:5175455955" className="text-charcoal-900/70 text-sm hover:text-sage-500 transition-colors" data-id="element-249">
                      (517) 545-5955
                    </a>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-250">
                <div className="flex items-start gap-3 mb-4" data-id="element-251">
                  <Mail className="text-sage-500 flex-shrink-0 mt-1" size={20} data-id="element-252" />
                  <div data-id="element-253">
                    <h3 className="font-serif text-lg text-charcoal-900 mb-2" data-id="element-254">
                      Email Us
                    </h3>
                    <a href="mailto:info@downhomeinteriors.com" className="text-charcoal-900/70 text-sm hover:text-sage-500 transition-colors" data-id="element-255">
                      info@downhomeinteriors.com
                    </a>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-256">
                <div className="flex items-start gap-3 mb-4" data-id="element-257">
                  <Clock className="text-sage-500 flex-shrink-0 mt-1" size={20} data-id="element-258" />
                  <div data-id="element-259">
                    <h3 className="font-serif text-lg text-charcoal-900 mb-3" data-id="element-260">
                      Store Hours
                    </h3>
                    <div className="space-y-2 text-sm text-charcoal-900/70" data-id="element-261">
                      <div className="flex justify-between" data-id="element-262">
                        <span data-id="element-263">Sunday</span>
                        <span data-id="element-264">10:30am – 3:30pm</span>
                      </div>
                      <div className="flex justify-between" data-id="element-265">
                        <span data-id="element-266">Monday</span>
                        <span data-id="element-267">10am – 4pm</span>
                      </div>
                      <div className="flex justify-between" data-id="element-268">
                        <span data-id="element-269">Tue – Thu</span>
                        <span data-id="element-270">10am – 5:30pm</span>
                      </div>
                      <div className="flex justify-between" data-id="element-271">
                        <span data-id="element-272">Friday</span>
                        <span data-id="element-273">10am – 5pm</span>
                      </div>
                      <div className="flex justify-between" data-id="element-274">
                        <span data-id="element-275">Saturday</span>
                        <span data-id="element-276">Closed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-277">
                <h3 className="font-serif text-lg text-charcoal-900 mb-4" data-id="element-278">
                  Follow Us
                </h3>
                <div className="flex gap-4" data-id="element-279">
                  <a href="https://www.facebook.com/DownTowneApparel/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-sage-100 hover:bg-sage-200 flex items-center justify-center transition-colors" aria-label="Facebook" data-id="element-280">
                    <Facebook className="text-sage-600" size={20} data-id="element-281" />
                  </a>
                  <a href="https://www.instagram.com/downhomeinteriors/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-sage-100 hover:bg-sage-200 flex items-center justify-center transition-colors" aria-label="Instagram" data-id="element-282">
                    <Instagram className="text-sage-600" size={20} data-id="element-283" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 px-4 bg-cream-100" data-id="element-284">
        <div className="max-w-7xl mx-auto" data-id="element-285">
          <div className="h-[500px] border border-taupe-200 shadow-card overflow-hidden" data-id="element-286">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2937.047240191924!2d-83.90287152328551!3d42.59674122011513!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8823475fb0e59093%3A0x1164ffa174cf8cad!2sDown%20Home%20Interiors!5e0!3m2!1sen!2sus!4v1768330470795!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Down Home Interiors Location" data-id="element-287" />
          </div>
        </div>
      </section>
    </Layout>;
}